<template>
  <div class="withdraw-container">
    <div class="withdraw-card">
      <!-- 标题 -->
      <div class="withdraw-header">
        <span class="withdraw-title">{{ $t('_txsq._bz') }}</span>
      </div>

      <!-- 币种选择 -->
      <div class="section">
        <div class="section-header">
          <span class="section-title">{{ $t('_txsq._bz') }}</span>
        </div>
        <div class="currency-grid">
          <div v-for="(vo, i) in currencyList" :key="i" class="currency-item" :class="{ active: currencyIndex === i }" @click="onCurrencyChange(i)">
            <img :src="require('../../static/img_icon/' + vo.text.toLowerCase() + '.png')" class="currency-icon" />
            <span class="currency-name">{{ vo.text }}</span>
          </div>
        </div>
      </div>

      <!-- 网络选择 -->
      <div class="section">
        <div class="section-header">
          <span class="section-title">{{ $t('_txsq._wl') }}</span>
        </div>
        <div class="network-grid">
          <div v-for="(vo, i) in protocolList" :key="i" class="network-item" :class="{ active: protocolIndex === i }" @click="onProtocolClick(i)">
            {{ vo.network }}
          </div>
        </div>
      </div>

      <!-- 余额 -->
      <div class="info-row">
        <span class="info-label">{{ $t('_txsq._ye') }}</span>
        <span class="info-value highlight">{{ balance }} {{ current.name }}</span>
      </div>

      <!-- 手续费 -->
      <div class="info-row">
        <span class="info-label">{{ $t('_txsq._sxf') }}</span>
        <span class="info-value">≈ {{ fee }} {{ current.name }}</span>
      </div>

      <!-- 最小提现 -->
      <div class="info-row">
        <span class="info-label">{{ $t('_txsq._zxtx') }}</span>
        <span class="info-value">≈ {{ transfer_min }} {{ current.name }}</span>
      </div>

      <!-- 提现地址 -->
      <div class="section">
        <div class="section-header">
          <span class="section-title">{{ $t('_txsq._txdz') }}</span>
        </div>
        <div class="select-wrapper">
          <select class="select-box" @change="onAddressChange">
            <option value="">{{ $t('_txsq._qxztxdz') }}</option>
            <option v-for="(vo, i) in current.address_list" :key="i" :value="vo.value">
              {{ vo.value }}
            </option>
          </select>
        </div>
      </div>

      <!-- 提现金额 -->
      <div class="section">
        <div class="section-header">
          <span class="section-title">{{ $t('_txsq._txje') }}</span>
        </div>
        <div class="amount-input-wrap">
          <input v-model="params.number" type="text" class="amount-input" :placeholder="$t('_txsq._qsrtxje')" />
          <button class="btn-max" @click="onAll">{{ $t('_tx._qb') }}</button>
        </div>
      </div>

      <!-- 验证码 -->
      <div class="section" v-if="user.is_moni == 1">
        <div class="section-header">
          <span class="section-title">{{ $t('_txsq._yxyzm') }}</span>
        </div>
        <div class="code-input-wrap">
          <input v-model="params.code" type="text" class="code-input" :placeholder="$t('_txsq._qsryxyzm')" />
          <button class="btn-code" :disabled="!hasSend" @click="onSendCode">
            {{ codeBtnText }}
          </button>
        </div>
      </div>

      <!-- 操作按钮 -->
      <div class="action-buttons">
        <button class="btn-back" @click="onBack('wallet')">
          <i class="fas fa-arrow-left"></i>
          {{ $t('_sp._fanh') }}
        </button>
        <button class="btn-withdraw" @click="onSubmit">
          <i class="fas fa-paper-plane"></i>
          {{ $t('_txsq._ljtx') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { countdown } from '@/utils/tools'

export default {
  name: 'WithdrawVue',
  data() {
    return {
      currencyList: [],
      currencyIndex: 0,
      protocolList: [],
      protocolIndex: 0,
      current: {},
      user: {},
      params: {
        address: '',
        number: '',
        code: ''
      },
      isload: false,
      c_name: '',
      balance: 0,
      fee: '0.00',
      fee_max: '0.00',
      fee_min: '0.00',
      transfer_min: '0.001',
      hasSend: true,
      codeBtnText: this.$t('_yzm._fsyzm')
    }
  },
  created() {
    this.getCurrencyList()
    this.user = this.$common.getInfo() || {}
  },
  methods: {
    onBack(name) {
      this.$router.push({ name: name })
    },

    getCurrencyList() {
      this.$api.chain.getCurrencyList().then((res) => {
        this.currencyList = res.data || []
        if (this.currencyList.length > 0) {
          this.onCurrencyChange(0)
        }
      })
    },

    onCurrencyChange(i) {
      this.currencyIndex = i
      this.protocolList = this.currencyList[i]?.protocol || []
      this.onProtocolClick(0)
    },

    onProtocolClick(i) {
      this.protocolIndex = i
      this.params.address = ''
      this.current = this.protocolList[i] || {}
      this.c_name = this.current.name + '_' + this.current.network

      this.fee_max = parseFloat(this.current.transfer_fee_max) || 0
      this.fee_min = parseFloat(this.current.transfer_fee_min) || 0
      this.transfer_min = parseFloat(this.current.transfer_min) || 0.001

      this.setCache()
      this.balance = parseFloat((parseFloat(this.current.wallet?.number || 0) - this.fee).toFixed(8))
      if (this.balance < 0) this.balance = 0
    },

    setCache() {
      const k1 = this.c_name + '_tv_fee'
      const k2 = this.c_name + '_tv_fee_t'
      const now = parseInt(new Date().getTime() / 1000)

      let feeData = localStorage.getItem(k1)
      if (feeData && feeData.startsWith('{')) {
        try {
          const parsed = JSON.parse(feeData)
          this.fee = parsed.data || parsed
        } catch (e) {
          this.fee = this.generateNewFee()
        }
      } else {
        this.fee = parseFloat(feeData) || this.generateNewFee()
      }

      const expire = parseInt(localStorage.getItem(k2) || 0)
      if (expire - now < 0) {
        this.fee = this.generateNewFee()
        localStorage.setItem(k1, this.fee.toString())
        localStorage.setItem(k2, (now + 60).toString())
      }
    },

    generateNewFee() {
      const min = this.fee_min || 0
      const max = this.fee_max || 0
      return parseFloat((Math.random() * (max - min) + min).toFixed(6))
    },

    valid() {
      if (!this.params.address) {
        this.$message.warning(this.$t('_txsq._qxztxdz'))
        return false
      }
      if (!this.params.number) {
        this.$message.warning(this.$t('_txsq._qsrtxje'))
        return false
      }
      if (!this.params.code && this.user.is_moni == 1) {
        this.$message.warning(this.$t('_txsq._qsryxyzm'))
        return false
      }
      return true
    },

    onAddressChange(e) {
      this.params.address = e.target.value
    },

    onSubmit() {
      if (!this.valid()) return
      if (this.isload) return

      this.isload = true
      const hide = this.$message.loading({ content: this.$t('_a._jzz'), key: 'msg' })

      this.params.c_id = this.current.id
      this.params.wallet_id = this.current.wallet?.id
      this.params.fee = Number(this.fee)
      this.params.number = Number(this.params.number)

      this.$api.userWallet
        .withdraw(this.params)
        .then((res) => {
          hide()
          this.isload = false
          if (res.data?.code == 1) {
            this.$message.warning({ content: res.data.msg, key: 'msg' })
            return
          }
          this.$message.success({ content: res.msg || '提现成功', key: 'msg' })
          this.params.number = ''
        })
        .catch(() => {
          hide()
          this.isload = false
          this.$message.error('提现失败，请重试')
        })
    },

    onAll() {
      this.params.number = this.balance > 0 ? this.balance : ''
    },

    onSendCode() {
      if (!this.hasSend) return

      const hide = this.$message.loading({ content: this.$t('_yzm._fsz'), key: 'msg' })
      const key = this.$md5('withdraw')

      this.$api.code
        .sendCode({ scene: 'withdraw' })
        .then((res) => {
          hide()
          if (res.code == 1) {
            this.$message.warning({ content: res.msg, key: 'msg' })
            return
          }
          this.$message.success({ content: this.$t('_yzm._fscg'), key: 'msg' })
          countdown.start(key, res.data.exp)
          countdown.run(key, this.CallTime)
        })
        .catch(() => {
          hide()
        })
    },

    CallTime(time) {
      if (time == 0) {
        this.hasSend = true
        this.codeBtnText = this.$t('_yzm._fsyzm')
      } else {
        this.hasSend = false
        this.codeBtnText = this.$t('_yzm._cxfs', { time: time })
      }
    }
  }
}
</script>

<style scoped>
/* ============================================================
   提现页面 - 深灰主题
   ============================================================ */

.withdraw-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0;
}

.withdraw-card {
  max-width: 800px;
  margin: 0 auto;
  background: #1a1f26;
  border-radius: 16px;
  border: 1px solid #2a3038;
  padding: 28px 32px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

/* ============================================================
   标题
   ============================================================ */
.withdraw-header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #2a3038;
}

.withdraw-title {
  font-size: 20px;
  font-weight: 700;
  color: #e8edf2;
}

/* ============================================================
   区块
   ============================================================ */
.section {
  margin-bottom: 20px;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #8a949f;
}

/* ============================================================
   币种选择
   ============================================================ */
.currency-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
}

.currency-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 12px 8px;
  background: #0f1419;
  border-radius: 10px;
  border: 2px solid #2a3038;
  cursor: pointer;
  transition: all 0.3s ease;
}

.currency-item:hover {
  border-color: #3a4652;
  transform: translateY(-2px);
}

.currency-item.active {
  border-color: #ffb300;
  background: rgba(255, 179, 0, 0.06);
}

.currency-icon {
  width: 36px;
  height: 36px;
  object-fit: contain;
}

.currency-name {
  font-size: 13px;
  font-weight: 600;
  color: #8a949f;
}

.currency-item.active .currency-name {
  color: #ffb300;
}

/* ============================================================
   网络选择
   ============================================================ */
.network-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.network-item {
  padding: 6px 20px;
  background: #0f1419;
  border-radius: 18px;
  border: 1px solid #2a3038;
  color: #8a949f;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.network-item:hover {
  border-color: #3a4652;
  color: #e8edf2;
}

.network-item.active {
  border-color: #ffb300;
  background: rgba(255, 179, 0, 0.06);
  color: #ffb300;
}

/* ============================================================
   信息行
   ============================================================ */
.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  background: #0f1419;
  border-radius: 8px;
  border: 1px solid #2a3038;
  margin-bottom: 10px;
}

.info-label {
  font-size: 14px;
  color: #6a7a8a;
  font-weight: 500;
}

.info-value {
  font-size: 14px;
  color: #e8edf2;
  font-weight: 500;
}

.info-value.highlight {
  color: #ffb300;
  font-weight: 700;
}

/* ============================================================
   选择框
   ============================================================ */
.select-wrapper {
  position: relative;
}

.select-box {
  width: 100%;
  height: 44px;
  padding: 0 16px;
  background: #0f1419;
  border: 1px solid #2a3038;
  border-radius: 10px;
  color: #e8edf2;
  font-size: 14px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  outline: none;
  cursor: pointer;
  transition: border-color 0.3s;
}

.select-box:focus {
  border-color: #ffb300;
  box-shadow: 0 0 0 3px rgba(255, 179, 0, 0.08);
}

.select-box option {
  background: #1a1f26;
  color: #e8edf2;
}

.select-wrapper::after {
  content: '▼';
  position: absolute;
  top: 50%;
  right: 14px;
  transform: translateY(-50%);
  color: #6a7a8a;
  font-size: 10px;
  pointer-events: none;
}

/* ============================================================
   金额输入
   ============================================================ */
.amount-input-wrap {
  display: flex;
  gap: 10px;
}

.amount-input {
  flex: 1;
  height: 44px;
  padding: 0 16px;
  background: #0f1419;
  border: 1px solid #2a3038;
  border-radius: 10px;
  color: #e8edf2;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s;
}

.amount-input:focus {
  border-color: #ffb300;
  box-shadow: 0 0 0 3px rgba(255, 179, 0, 0.08);
}

.amount-input::placeholder {
  color: #4a5662;
}

.btn-max {
  padding: 0 20px;
  height: 44px;
  background: rgba(255, 179, 0, 0.12);
  border: 1px solid #ffb300;
  border-radius: 10px;
  color: #ffb300;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-max:hover {
  background: rgba(255, 179, 0, 0.2);
}

/* ============================================================
   验证码输入
   ============================================================ */
.code-input-wrap {
  display: flex;
  gap: 10px;
}

.code-input {
  flex: 1;
  height: 44px;
  padding: 0 16px;
  background: #0f1419;
  border: 1px solid #2a3038;
  border-radius: 10px;
  color: #e8edf2;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s;
}

.code-input:focus {
  border-color: #ffb300;
  box-shadow: 0 0 0 3px rgba(255, 179, 0, 0.08);
}

.code-input::placeholder {
  color: #4a5662;
}

.btn-code {
  padding: 0 20px;
  height: 44px;
  background: #0f1419;
  border: 1px solid #2a3038;
  border-radius: 10px;
  color: #8a949f;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.btn-code:hover:not(:disabled) {
  border-color: #3a4652;
  color: #e8edf2;
}

.btn-code:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ============================================================
   操作按钮
   ============================================================ */
.action-buttons {
  display: flex;
  gap: 12px;
  margin-top: 8px;
}

.btn-back {
  flex: 0 0 auto;
  padding: 12px 24px;
  border: 1px solid #2a3038;
  border-radius: 10px;
  background: transparent;
  color: #8a949f;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-back:hover {
  background: rgba(255, 255, 255, 0.04);
  border-color: #3a4652;
  color: #e8edf2;
}

.btn-withdraw {
  flex: 1;
  padding: 12px 20px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #ffb300, #f57c00);
  color: #0b0d0f;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-withdraw:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(255, 179, 0, 0.3);
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 640px) {
  .withdraw-card {
    padding: 20px 18px 18px;
    border-radius: 12px;
  }

  .withdraw-title {
    font-size: 17px;
  }

  .currency-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
  }

  .currency-item {
    padding: 10px 6px;
  }

  .currency-icon {
    width: 30px;
    height: 30px;
  }

  .currency-name {
    font-size: 12px;
  }

  .action-buttons {
    flex-direction: column;
  }

  .btn-back {
    flex: 1;
    padding: 10px 16px;
    font-size: 14px;
  }

  .btn-withdraw {
    padding: 10px 16px;
    font-size: 14px;
  }
}

@media (max-width: 400px) {
  .withdraw-card {
    padding: 16px 12px 14px;
  }

  .currency-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .currency-item {
    padding: 8px 6px;
  }

  .currency-icon {
    width: 26px;
    height: 26px;
  }

  .currency-name {
    font-size: 11px;
  }

  .network-item {
    font-size: 12px;
    padding: 5px 14px;
  }

  .info-row {
    padding: 8px 12px;
  }

  .info-label,
  .info-value {
    font-size: 13px;
  }

  .amount-input,
  .code-input {
    font-size: 13px;
    height: 40px;
  }

  .btn-max,
  .btn-code {
    height: 40px;
    font-size: 12px;
    padding: 0 14px;
  }

  .btn-back,
  .btn-withdraw {
    font-size: 13px;
    padding: 8px 14px;
  }
}
</style>
